import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../components/Helpper/Loader";
import { getPublicAppContent } from "../services/web/webServices";

const KEY_ALIASES = {
  "privacy-policy": "privacy_policy",
  privacy_policy: "privacy_policy",
  "terms-and-conditions": "terms_condition",
  terms_condition: "terms_condition",
  "about-us": "about_us",
  about_us: "about_us",
};

function PublicAppContent() {
  const { key } = useParams();
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang");

  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const resolvedKey = KEY_ALIASES[key] || key;
  const isSpanish = lang === "sp" || lang === "es";

  useEffect(() => {
    setLoading(true);
    setError("");

    getPublicAppContent()
      .then((res) => {
        const items = Array.isArray(res?.data?.data) ? res.data.data : [];
        const match = items.find((item) => item.key === resolvedKey);
        if (match) {
          setContent(match);
        } else {
          setError("Content not found.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Unable to load content. Please try again later.");
        setLoading(false);
      });
  }, [resolvedKey]);

  const title = content
    ? isSpanish
      ? content.title_sp || content.title
      : content.title
    : "";

  const description = content
    ? isSpanish
      ? content.description_sp || content.description
      : content.description
    : "";

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {loading ? (
          <div style={styles.loaderWrap}>
            <Loader />
          </div>
        ) : error ? (
          <div style={styles.messageBox}>
            <h1 style={styles.errorTitle}>Not Found</h1>
            <p style={styles.errorText}>{error}</p>
          </div>
        ) : (
          <>
            <header style={styles.header}>
              <h1 style={styles.title}>{title?.trim()}</h1>
            </header>
            <article style={styles.body}>{description}</article>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f5f6f8",
    padding: "40px 20px",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  container: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
    padding: "40px 48px",
    minHeight: "300px",
  },
  loaderWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  },
  header: {
    borderBottom: "2px solid #64A433",
    marginBottom: "28px",
    paddingBottom: "16px",
  },
  title: {
    margin: 0,
    fontSize: "28px",
    fontWeight: 700,
    color: "#333",
    lineHeight: 1.3,
  },
  body: {
    fontSize: "16px",
    lineHeight: 1.7,
    color: "#444",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  messageBox: {
    textAlign: "center",
    padding: "40px 20px",
  },
  errorTitle: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "12px",
  },
  errorText: {
    fontSize: "16px",
    color: "#666",
  },
};

export default PublicAppContent;
